import { useEffect, useRef, useState } from "react";
import { settings } from "../../constants/spaceFeedImageSettings";
import ImageSlider from "../common/ImageSlider";
import InfiniteScroll from "react-infinite-scroll-component";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons"; // Importing the star icon from Font Awesome
import api from "../../api/config";
import { toast } from "react-toastify";
import SkeletonLoader from "../common/SkeletonLoader";

const UserSpaceFeedList = ({ spaceFeedList, loadMore, hasMore, loading }) => {
  const scrollableRef = useRef();
  const [favouriteList, setFavouriteList] = useState([]);

  let auth = localStorage?.getItem("data");
  auth = JSON.parse(auth);

  const navigate = useNavigate();

  const handleStarClick = (e, id) => {
    e.preventDefault();
    const isFavourite = favouriteList.some((item) => item?.spaceFeedId === id);
    const updatedFavourites = isFavourite
      ? favouriteList.filter((product) => product?.spaceFeedId !== id)
      : [...favouriteList, { spaceFeedId: id }]; // Add product if not already favourited
    setFavouriteList(updatedFavourites);

    handleFavourite(id, isFavourite ? 0 : 1);
  };

  const handleFavourite = async (id, action) => {
    if (!!auth?.jwt) {
      try {
        await api.post(`shortlist-space-feed/${id}/${action}`);
        toast.success(
          `${action === 1 ? "Added to Favourite" : "Removed from Favourite"}`
        );
      } catch (error) {
        toast.error("Error adding or removing from favorites!");
        console.error(error, "error");
      }
    } else {
      navigate("/login");
    }
  };

  const fetchFavouriteList = async () => {
    try {
      const response = await api.get("/shortlisted-space-feed");
      if (response?.data?.status === 200) {
        setFavouriteList(response?.data?.response);
      }
    } catch (error) {
      //console.logerror);
    }
  };

  useEffect(() => {
    if (!!auth?.jwt) {
      fetchFavouriteList();
    }
  }, []);

  return (
    <>
      <InfiniteScroll
        dataLength={spaceFeedList.length}
        next={loadMore}
        hasMore={hasMore}
        scrollThreshold={0.5}
        loader={
          <>
            <SkeletonLoader count={4} data={spaceFeedList} loading={loading} />
          </>
        }
        scrollableTarget={scrollableRef.current}
      >
        <div className="row" style={{ justifyContent: "flex-start" }}>
          {spaceFeedList.map((item, index) => {
            const formattedAddress = [
              item?.address1
                ?.replace(/USA/i, "")
                ?.replace(/\bUnited States\b/gi, '')
                ?.replace(/\bNew York\b,?\s*/gi, '')
                .replace(/,\s*$/, ""),
                item?.address2
                ?.replace(/USA/i, "")
                ?.replace(/\bUnited States\b/gi, '')
                ?.replace(/\bNew York\b,?\s*/gi, '')
                .replace(/,\s*$/, ""),
              item?.city &&
              !item?.address1?.includes(item.city) &&
              !item?.address2?.includes(item.city)
                ? item.city
                : null,
              item?.state &&
              !item?.address1?.includes(item.state) &&
              !item?.address2?.includes(item.state)
                ? item.state
                : null,
              item?.pin &&
              !item?.address1?.includes(item.pin) &&
              !item?.address2?.includes(item.pin)
                ? item.pin
                : null,
            ]
              .filter(Boolean)
              .join(", ");

            return (
              <div
                className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
                key={index}
              >
                <Link
                  to={`/property-detail/${item?.spaceFeedId}`}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <>
                    {item?.spaceFeedMedia?.length > 0 && (
                      <>
                        {item?.spaceFeedMedia.length === 1 ? (
                          <>
                            {item?.spaceFeedMedia[0]?.url?.includes("mp4") ? (
                              <>
                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                    height: "300px",
                                  }}
                                >
                                  <video
                                    type="video/mp4"
                                    src={item?.spaceFeedMedia[0]?.url}
                                    alt="Card cap"
                                    style={{
                                      position: "absolute",
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                    controls
                                  />
                                  {(auth?.role === "user" || !auth?.role) && (
                                    <FontAwesomeIcon
                                      icon={faStar}
                                      onClick={(e) =>
                                        handleStarClick(e, item?.spaceFeedId)
                                      }
                                      className="star-icon"
                                      style={{
                                        color:
                                          !!auth?.jwt &&
                                          favouriteList.some(
                                            (favProduct) =>
                                              favProduct.spaceFeedId ===
                                              item?.spaceFeedId
                                          ) &&
                                          "#F5C000",
                                        cursor: "default",
                                      }}
                                    />
                                  )}
                                </div>
                                <div className="px-3 py-2">
                                  <h5 className=" mb-0">{item?.name}</h5>
                                  <p className="mb-0">
                                    {item?.address1
                                      ?.replace(/USA/i, "")
                                      ?.replace(/\bUnited States\b/gi, '')
                                      ?.replace(/\bNew York\b,?\s*/gi, '')
                                      .replace(/,\s*$/, "")}
                                    
                                  </p>
                                </div>
                              </>
                            ) : (
                              <>
                                <div style={{ position: "relative" }}>
                                  <img
                                    className="card-img img-fluid w-100"
                                    src={item?.spaceFeedMedia[0]?.url}
                                    alt="Card cap"
                                    style={{ height: "300px" }}
                                  />
                                  {(auth?.role === "user" || !auth?.role) && (
                                    <FontAwesomeIcon
                                      icon={faStar}
                                      onClick={(e) =>
                                        handleStarClick(e, item?.spaceFeedId)
                                      }
                                      className="star-icon"
                                      style={{
                                        color:
                                          !!auth?.jwt &&
                                          favouriteList.some(
                                            (favProduct) =>
                                              favProduct.spaceFeedId ===
                                              item?.spaceFeedId
                                          ) &&
                                          "#F5C000",
                                        cursor: "default",
                                      }}
                                    />
                                  )}
                                </div>
                                <div className="px-3 py-2">
                                  <h5 className="mb-0">{item?.name}</h5>
                                  <p className="mb-0">
                                  {item?.address1
                                      ?.replace(/USA/i, "")
                                      ?.replace(/\bUnited States\b/gi, '')
                                      ?.replace(/\bNew York\b,?\s*/gi, '')
                                      .replace(/,\s*$/, "")}
                                  </p>
                                </div>
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <ImageSlider
                              handleImageClick={() =>
                                navigate(
                                  `/property-detail/${item?.spaceFeedId}`
                                )
                              }
                              handleClick={handleStarClick}
                              auth={auth}
                              height={300}
                              className="card-img img-fluid w-100"
                              settings={settings}
                              item={item}
                              style={{
                                color:
                                  !!auth?.jwt &&
                                  favouriteList.some(
                                    (favProduct) =>
                                      favProduct.spaceFeedId ===
                                      item?.spaceFeedId
                                  ) &&
                                  "#F5C000",
                                cursor: "default",
                              }}
                            />
                            <div className="px-3 py-2">
                              <h5 className="mb-0">{item?.name}</h5>
                              <p className="mb-0">
                              {item?.address1
                                      ?.replace(/USA/i, "")
                                      ?.replace(/\bUnited States\b/gi, '')
                                      ?.replace(/\bNew York\b,?\s*/gi, '')
                                      .replace(/,\s*$/, "")}
                              </p>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </>
                </Link>
              </div>
            );
          })}
        </div>
      </InfiniteScroll>
    </>
  );
};

export default UserSpaceFeedList;
